<template>
  <Modal width="742px" centered :visible="visible" :closable="false" :getContainer="false" @cancel="onClose">
    <div class="content-wrapper">
      <img class="mask" src="/image/dialog-background-mask.png">
      <img class="background-icon" src="/image/dialog-bakcground-woman.png">
      <p class="content">
        We are pleased to inform you that in order to provide better service, the eLearning website address (URL) will be changed as follows. <br>
        Your learning record and earned certificates are both migrated to the new site. If you meet any problem, please send email to eLearninglobal@hikvision.com. We apologize for any inconvenience caused.<br>
        <br>
        For customers who have saved our website as a “Favorite” or “Bookmark”, please update the settings.<br>
        • New URL: {{ isEU ? 'https://elearning.hikvision.com/eu/' : 'https://elearning.hikvision.com/asia/' }}<br>
        *It will be automatically redirected from the old URL to the new URL.<br>
        <br>
        • Scheduled date and time<br>
        <span v-if="isEU" class="emphasis">1st, Feb, 2024 at 2:00 a.m. (UTC +0)</span><br>
        <span v-if="isAsia" class="emphasis">4th, July, 2024 at 9:00 a.m. (UTC+8)</span><br>
        <br>
        Thank you for your understanding and support.
      </p>
    </div>
    <template #footer>
      <div class="modal-footer">
        <Button @click="onClose">OK, I got it</Button>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { Modal } from 'ant-design-vue'
import { Button } from '@/components/common'
import { useStoreHooks } from '@/store/hook'
import { updateMigrationPopStatus } from '@/request/api/user'

export default defineComponent({
  components: {
    Modal,
    Button
  },
  props: {
    visible: Boolean
  },
  emits: ['close'],
  setup (props, ctx) {
    const { state: _state } = useStoreHooks()
    const isArSite = computed(() => _state.global.isArSite)

    return {
      isArSite,
      isAsia: _state.global.isAsia,
      isEU: _state.global.isEU,
      onClose () {
        updateMigrationPopStatus()
        ctx.emit('close', false)
      }
    }
  }
})

</script>

<style lang="less" scoped>
.content-wrapper {
  position: relative;
  padding: 173px 34px 0;
  margin-bottom: 20px;
  .mask {
    position: absolute;
    width: 100%;
    top: 0;
    right: 0;
    pointer-events: none;
  }
  .background-icon {
    position: absolute;
    height: 145px;
    top: 9px;
    left: 50%;
    transform: translateX(-50%);
  }
  .content {
    font-size: 14px;
    font-weight: 400;
    color: #333;
    white-space: pre-line;
    .emphasis {
      font-weight: 600;
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}

@media only screen and (max-width: 992px) {
  .content-wrapper {
    padding: 14.6rem 1.5rem 0;
    margin-bottom: 2rem;
    .background-icon {
      height: 11rem;
    }
  }
}
</style>
